var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('div',{staticStyle:{"width":"30%"},attrs:{"name":"Active"}},[_c('h4',[_vm._v("你已經成功完成國立勤益科技大學【產運處報名暨繳費系統】帳號啟用")]),_c('h4',[_vm._v("請點擊以下網址登入你的帳戶")]),_c('span',{staticClass:"nav-link active bg-info text-white rounded"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("登入")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }